import { createTypesFor } from "utils";

export const prefixes = {
  CHANGE_SORT: "[sort] change ",
  SET_SORT: "[sort] set "
};

export const typesFor = domain => createTypesFor(domain, prefixes);
